var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__status"},[_c('BAlert',{attrs:{"show":"","variant":_vm.alertClass}},[_vm._v(_vm._s(_vm.statusText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }